import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import Product from "../../../types/product";
import Button from "../../tailwind/button";
import Modal from "../../tailwind/modal";
import ModalBody from "../../tailwind/modal-body";
import ModalDialog from "../../tailwind/modal-dialog";
import Row from "../../tailwind/row";
import SuggestItem from "./item";
import SuggestSection from "./section";

interface RequestForm {
  products: number[];
}

export interface IProductSuggestProps {
  show: boolean;
  mainProducts: Product[];
  optionalProducts: Product[];
  relatedProducts: Product[];

  onCancel: () => void;
  onSubmit: (products: number[]) => void;
}

export default function ProductSuggest({
  show,
  mainProducts,
  optionalProducts,
  relatedProducts,
  onCancel,
  onSubmit,
}: IProductSuggestProps) {
  const { register, handleSubmit } = useForm<RequestForm>();
  const { t } = useTranslation(undefined, {
    keyPrefix: "ProductSuggest",
  });

  return (
    <Modal show={show}>
      <ModalDialog>
        <div className="modal-content">
          <ModalBody>
            <form
              onSubmit={handleSubmit((f) => {
                // console.log("ProductSuggest.handleSubmit", f);
                return onSubmit(f.products);
              })}
            >
              <table>
                <tbody>
                  <SuggestSection title={t("YourItems")} />
                  {mainProducts.map((p) => (
                    <SuggestItem
                      key={p.id}
                      register={register("products")}
                      product={p}
                      selected
                      mandatory
                    />
                  ))}
                  {optionalProducts.map((p) => (
                    <SuggestItem
                      key={p.id}
                      register={register("products")}
                      product={p}
                      selected
                    />
                  ))}
                  {relatedProducts.some(() => true) && (
                    <SuggestSection title={t("RelatedItems")} />
                  )}
                  {relatedProducts.map((p) => (
                    <SuggestItem
                      key={p.id}
                      register={register("products")}
                      product={p}
                    />
                  ))}
                </tbody>
              </table>
              <Row>
                <Button
                  type="submit"
                  className="btn-primary form-group btn-block col-6"
                  text={t("Submit")}
                />
                <Button
                  className="btn-danger form-group btn-block col-6"
                  text={t("Cancel")}
                  onClick={onCancel}
                />
              </Row>
            </form>
          </ModalBody>
        </div>
      </ModalDialog>
    </Modal>
  );
}
